import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  components: {
    MuiTableCell: {
      styleOverrides: {
        // eslint-disable-next-line no-shadow
        root: ({ theme }) => {
          theme.unstable_sx({
            borderBottom: 'none',
          });
        },
      },
      variants: [
        {
          props: { variant: 'head' },
          style: {
            fontWeight: 'bold',
            textAlign: 'center',
            fontSize: '20px',
          },
        },
        {
          props: { variant: 'body' },
          style: {
            textAlign: 'center',
            fontSize: '20px',
          },
        },
      ],
    },
    MuiListItem: {
      styleOverrides: {
        // eslint-disable-next-line no-shadow
        root: ({ theme }) => {
          theme.unstable_sx({
            justifyContent: 'center',
          });
        },
      },
    },
    MuiAlert: {
      variants: [
        {
          props: { variant: 'cookie_banner' },
          style: {
            backgroundColor: '#f5f5f5',
            position: 'fixed',
            bottom: 0,
            left: 0,
            width: '100%',
            zIndex: 9999,
            justifyContent: 'space-between',
            '& .MuiAlert-message': {
              minWidth: '90%',
            },
          },
        },
      ],
    },
    MuiDialog: {
      variants: [
        {
          props: { variant: 'cookie_preferences' },
          style: {
            '& .MuiDialog-paper': { height: '500px' },
          },
        },
      ],
    },
  },
});

export default theme;
